"use client";
import { useRef, useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import useResourcePageSideRail from "@/monarch/rules/resourcePageSideRail/useResourcePageSideRail";

interface StickyProps {
  rootclassname?: string;
  stickyclassname?: string;
  hassiderail?: string;

  children: React.ReactNode;
}

export default function Sticky({
  rootclassname,
  stickyclassname,
  hassiderail = "false",
  children,
}: StickyProps) {
  const { variant } = useResourcePageSideRail();
  const pathname = usePathname();
  const divRef = useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState(false);
  const [navTop, setNavTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && !isSticky) {
        const rect = divRef.current.getBoundingClientRect();
        setNavTop(rect.top + window.scrollY);
      }

      const shouldBeSticky = window.scrollY > navTop - 10; // 10px buffer
      setIsSticky(shouldBeSticky);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [navTop, isSticky]);

  // hide the sticky toc if the siderail is enabled and on a resources page and there is a siderail component
  // hassiderail is a string because it's a prop coming from the cms/shortcode
  console.log(variant, pathname, hassiderail);
  if (
    variant === "siderail" &&
    pathname?.includes("/resources") &&
    hassiderail === "true"
  ) {
    return (
      <div
        ref={divRef}
        className={cn(
          isSticky ? "fixed top-0 left-0 right-0 z-50 shadow-lg" : "",
          rootclassname,
          isSticky ? stickyclassname : "",
        )}
      >
        {children}
      </div>
    );
  }

  return <></>;
}
